module.exports = __webpack_public_path__ + "staticcomp/img/cover.a277db0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/2/cover.jpg
// module id = jm47
// module chunks = 39